<div
  class="toast align-items-center text-white border-0 mb-1"
  [ngClass]="{
    success: type === ToastType.Success,
    warning: type === ToastType.Warning,
    error: type === ToastType.Error,
    info: type === ToastType.Info,
  }"
  role="alert"
  aria-live="assertive"
  aria-atomic="true"
  (click)="hide()"
  (keydown.enter)="hide()"
>
  <div class="d-flex">
    <div class="toast-body">
      <div class="toast-title">
        {{ title }}
      </div>
      <div class="toast-message">
        {{ message }}
      </div>
    </div>
  </div>
</div>
